import React, { Component } from 'react';
import ReactHighcharts from 'react-highcharts';


class Dashboard extends Component {

    componentDidMount() {

    }

    renderCharts() {

        const config = {
            title: {
                text: null
            },

            subtitle: {
                text: null
            },
            tooltip: {
                enabled: false
            },

            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                    day: '%e %b %Y'
                }
            },

            yAxis: [{
                className: 'highcharts-color-0',
                title: {
                    text: null
                },
                labels: {
                    enabled: false
                },
                gridLineDashStyle: 'longdash',
                gridLineColor: '#197F07',
                lineWidth: 1,
                tickAmount: 7,
            }, {
                className: 'highcharts-color-1',
                opposite: true,
                title: {
                    text: null
                },
                gridLineWidth: 0,
                linkedTo: 0,
                labels: {
                    enabled: false
                },
                showFirstLabel: false,
            }],

            legend: {
                enabled: false
            },

            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    pointStart: 2010
                }
            },

            series: [{
                data: [0, 30000, 90000, 58000, 200000, 80000, 30000, 80000, 150000, 150000,
                    80000
                ],
                pointStart: Date.UTC(2017, 0, 1),
                pointInterval: 24 * 3600 * 1000, // one day
                marker: {
                    enabled: false
                },
                states: {
                    hover: {
                        enabled: false
                    }
                }
            }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }
        };

        return (
            <ReactHighcharts config={config} id="state-chart" style={{ width: '100%', height: 334 }} />
        );
    }

    render() {
        return (
            <div className="main-content">
                <div className="page-title">Dashboard</div>
                <div className="divider"></div>
                <div className="db-state">
                    <div className="row">
                        <div className="col-sm">
                            <div className="row">
                                <div className="col-3">
                                    <img src="/resources/img/ic-awaiting_payment.svg" alt="state awaiting payment" />
                                </div>
                                <div className="col-9">
                                    <p>Awaitng Payment</p>
                                    <label>100 Orders</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm">
                            <div className="row">
                                <div className="col-3">
                                    <img src="/resources/img/ic-awaiting_shipment-success.svg" alt="state awaitng shipment" />
                                </div>
                                <div className="col-9">
                                    <p>Awaitng Shipment</p>
                                    <label>10 Orders</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm">
                            <div className="row">
                                <div className="col-3">
                                    <img src="/resources/img/ic-member.svg" alt="state member" />
                                </div>
                                <div className="col-9">
                                    <p>Members</p>
                                    <label>200 Accounts</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="divider"></div>
                <div className="db-state-detail">
                    <div className="row">
                        <div className="col">
                            <div className="form-group dropdown sort-dropdown date-range">
                                <button className="btn dropdown-toggle sort-list date-range-list" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    10 Jul 2017 - 19 Jul 2017
                            </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <li>
                                        <a className="dropdown-item" href="#">20 Jul 2017 - 29 Jul 2017</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">30 Jul 2017 - 09 Aug 2017</a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">19 Aug 2017 - 29 Aug 2017</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <p>
                                <span className="circle blue-circle"></span>
                                <span className="sale">Sale</span> 315,000.00 ฿</p>
                        </div>
                    </div>
                </div>
                {this.renderCharts()}
            </div>
        )
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/views/dashboard/index.js